import { render } from "./VigikBreadCrumb.vue?vue&type=template&id=1fc4754b&scoped=true"
import script from "./VigikBreadCrumb.vue?vue&type=script&lang=js"
export * from "./VigikBreadCrumb.vue?vue&type=script&lang=js"

import "./VigikBreadCrumb.vue?vue&type=style&index=0&id=1fc4754b&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc4754b"]])

export default __exports__